<template>
  <div class="house-management">
    <div class="d-left" :class="{'d-left-hide':is_open_tree}">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right" :class="{'d-right-ext':is_open_tree}">
      <div class="d-right-exttag" @click="isOpenTree">
        <i class="el-icon-d-arrow-left" v-if="!is_open_tree"></i>
        <i class="el-icon-d-arrow-right" v-if="is_open_tree"></i>
      </div>
      <el-tabs type="border-card" v-model="card_index">
        <el-tab-pane label="房产信息" name="HouseList">
          <HouseList v-if="card_index==='HouseList'" />
        </el-tab-pane>
        <el-tab-pane label="房产日志" name="HouseLog">
          <HouseLog v-if="card_index==='HouseLog'" />
        </el-tab-pane>
        <el-tab-pane label="项目房产架构" name="HouseTree">
          <HouseTree v-if="card_index==='HouseTree'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import HouseList from "./components/house/HouseList";
import HouseLog from "./components/house/HouseLog";
import HouseTree from "./components/house/HouseTree";
export default {
  name: "HouseManagement",
  components: {
    HouseTree,
    HouseLog,
    HouseList,
    ErpTree,
  },
  data(){
    return{
      mainObj:{
        project_id:0,
        house_id:0,
        house_name:''
      },
      card_index:"HouseList",
      is_open_tree:false,
    }
  },
  provide(){
    return {
      mainObj:this.mainObj
    }
  },
  methods:{
    nodeClick(data) {
      if (data.type === "project") {
        this.mainObj.project_id = data.id;
      }
      if (data.type === "room") {
        this.mainObj.house_id = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.mainObj.house_name = tree_str;
    },
    isOpenTree(){
      this.is_open_tree = !this.is_open_tree;
    }
  }
};
</script>

<style lang="scss" scoped>
.house-management{
  display: flex;
  flex-direction: row;
  padding: 10px;

  .d-left {
    border-right: 1px solid #eee;
    width: 250px;
    transition: all 0.3s ease;

    &.d-left-hide{
      width: 0;
      overflow: hidden;
    }
  }
  .d-right {
    margin-left: 10px;
    width: calc(100% - 260px);
    position: relative;
    transition: all 0.3s ease;
    &.d-right-ext{
      width: calc( 100% - 10px );
    }
    .d-right-exttag{
      position: absolute;
      top: 50%;
      left: 0;
      width: 30px;
      height: 30px;
      background-color: rgba(0,0,0,0.5);
      z-index: 1;
      cursor: pointer;
      transform: translate(0,-50%);
      transition: all 0.3s ease;
      text-align: center;
      line-height: 30px;
      &:hover{
        background-color: rgba(0,0,0,0.5);
      }
      i{
        color: #fff;
        font-size: 20px;
        line-height: 30px;
        text-align: center;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/HouseManagement.vue